<template>
    <div>
      <b-sidebar
        id="sidebar-right"
        ref="filterSidebar"
        right
        text-variant="body"
        class="theme-bg-white e-mtavr-17 e-ts-12 e-zindex-1"
        bg-variant="white"
        shadow
        backdrop
        :backdrop-variant="variant"
        width="550px"
        @change="toggleBodyScrollbar"
        >
        <template #title>
                <h6 class="e-mtavr-17">მოთხოვნის დეტალები</h6>
        </template>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 h-100 pt-5">
            <perfect-scrollbar :options="{ wheelPropagation: true, suppressScrollX: true}" class="mb-4" style="height: 100%">
              <div class="row" v-if="!RequestDetailsData.requestForClient">
                <div class="col col-6">
                    <b-list-group :flush="true">
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                          <div class="text-muted e-nusx-8" v-if="RequestDetailsData.juridicalStatusId === 1">სახელი</div>
                          <div class="text-muted e-nusx-8" v-if="RequestDetailsData.juridicalStatusId === 2">დასახელება</div>
                          <div class="e-eng-font">
                          {{ RequestDetailsData.firstName }}
                          </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 1">
                            <div class="text-muted e-nusx-8">გვარი</div>
                            <div class="e-eng-font">
                            {{ RequestDetailsData.lastName }}
                            </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 1">
                            <div class="text-muted e-nusx-8">დაბადების თარიღი</div>
                            <div class="e-eng-font">
                            {{ RequestDetailsData.brthDate }}
                            </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 1">
                        <div class="text-muted e-nusx-8">პირადი ნომერი</div>
                        <div class="e-eng-font">
                            {{ RequestDetailsData.personalN }}
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 2">
                        <div class="text-muted e-nusx-8">საიდენტიფიკაციო ნომერი</div>
                        <div class="e-eng-font">
                            {{ RequestDetailsData.IdentNumber }}
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 1">
                            <div class="text-muted e-nusx-8">ქვეყანა</div>
                            <div class="e-eng-font">
                            {{ RequestDetailsData.country }}
                            </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 2">
                            <div class="text-muted e-nusx-8">რეგისტრაციის ქვეყანა </div>
                            <div class="e-eng-font">
                            {{ RequestDetailsData.registrationCountry }}
                            </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            <div class="text-muted e-nusx-8">მისამართი</div>
                            <div class="e-eng-font">
                            {{ RequestDetailsData.address }}
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div class="col col-6">
                    <b-list-group :flush="true">
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <div class="text-muted e-nusx-8">მოთხოვნის ნომერი</div>
                        <div class="e-eng-font">
                            {{ RequestDetailsData.id}}
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <div class="text-muted e-nusx-8">ტრანზაქციის <span class="e-text-eng-1">ID</span></div>
                        <div class="pl-3 e-eng-font">
                            <a href="javascript:void(0)" class="e-wrap">{{ RequestDetailsData.transactionN }}</a>
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <div class="text-muted e-nusx-8">მოთხოვნის დრო</div>
                        <div class="e-eng-font">
                            {{ RequestDetailsData.recDate}}
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <div class="text-muted e-nusx-8">მომხმარებელი</div>
                        <div>
                            {{ RequestDetailsData.userFirstName }} {{ RequestDetailsData.userLastName }}
                        </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div class="col col-12 bordered pt-5">
                    <div class="card">
                        <h6 class="card-header e-nusx-5 e-ts-09rem pb-1 pt-1">კომენტარები</h6>
                            <div class="card-body mb-1">
                                <div class="e-loader-back" v-if="commentsLoading">
                                    <div class="e-loader-content">
                                        <div class="ball-clip-rotate-multiple">
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <div class="e-nusx-8 e-bold e-loader-text">მუშავდება...</div>
                                    </div>
                                </div>
                                <div class="row">
                                <perfect-scrollbar always-visible :options="{ suppressScrollX: true, wheelPropagation: true}" class="chat-messages chat-scroll p-4 w-100" style="height: 100px; width: 100%">
                                    <div v-for="comment in comments" :key="comment.ID" :class="`chat-message-${comment.userName === WHBL_item.creatorUserName ? 'right' : 'left'}`" class="mb-2 w-100">
                                    <div>
                                            <!-- <img :src="`${publicUrl}img/avatars/${comment.username === WHBL_item.creatorUserName ? user.avatar : chatUser.avatar}`" class="ui-w-40 rounded-circle" alt> -->
                                        <div class="font-weight-semibold mb-1">{{comment.userName === WHBL_item.creatorUserName ? 'თქვენ' : comment.userName}}</div>
                                        <div class="text-muted small text-nowrap mt-1">
                                        <p class="text-muted small e-ts-05rem e-eng-font mt-1 mb-0">{{comment.recDate | momentDateOnly}}</p>
                                        <p class="text-muted small e-ts-05rem e-eng-font mb-0">{{comment.recDate | momentTimeOnly}}</p>
                                        </div>
                                    </div>
                                    <div class="flex-shrink-1 bg-lighter rounded py-2 px-3" :class="comment.userName === WHBL_item.creatorUserName ? 'mr-3' : 'ml-3'">
                                            <!-- <div class="font-weight-semibold mb-1">{{comment.userName === WHBL_item.creatorUserName ? 'თქვენ' : comment.userName}}</div> -->
                                            {{comment.commentText}}
                                    </div>
                                    </div>
                                </perfect-scrollbar>
                                <!-- / .chat-messages -->
                                <!-- Chat footer -->
                                <hr class="border-light m-0">
                                    <div class="flex-grow-0 w-100">
                                        <b-input-group>
                                        <b-input placeholder="დაამატე კომენტარი" class="e-nusx-8" v-model="CommentText"/>
                                        <b-btn variant="primary" slot="append" class="e-mtavr-17 btn-xs" @click="AddComment(CommentText)">დამატება</b-btn>
                                        </b-input-group>
                                    </div>
                                    <!-- / Chat footer -->
                                    </div>
                                </div>
                    </div>
                </div>
              </div>
              <div class="row" v-if="RequestDetailsData.requestForClient">
                <div class="col col-6">
                    <b-list-group :flush="true">
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                    <div class="text-muted e-nusx-8" v-if="RequestDetailsData.juridicalStatusId === 1">სახელი</div>
                    <div class="text-muted e-nusx-8" v-if="RequestDetailsData.juridicalStatusId === 2">დასახელება</div>
                    <div class="e-eng-font">
                    {{ RequestDetailsData.firstName }}
                    </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 1">
                            <div class="text-muted e-nusx-8">გვარი</div>
                            <div class="e-eng-font">
                            {{ RequestDetailsData.lastName }}
                            </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 1">
                            <div class="text-muted e-nusx-8">დაბადების თარიღი</div>
                            <div class="e-eng-font">
                            {{ RequestDetailsData.brthDate }}
                            </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <div class="text-muted e-nusx-8" v-if="RequestDetailsData.juridicalStatusId === 1">პირადი ნომერი</div>
                        <div class="text-muted e-nusx-8" v-if="RequestDetailsData.juridicalStatusId === 2">საიდენტიფიკაციო ნომერი</div>
                        <div class="e-eng-font" v-if="RequestDetailsData.juridicalStatusId === 2">
                            {{ RequestDetailsData.IdentNumber }}
                        </div>
                        <div class="e-eng-font" v-if="RequestDetailsData.juridicalStatusId === 1">
                            {{ RequestDetailsData.personalN }}
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 2">
                        <div class="text-muted e-nusx-8">რეგისტრაციის ნომერი</div>
                        <div class="e-eng-font">
                            {{ RequestDetailsData.registrationN }}
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="RequestDetailsData.juridicalStatusId === 2">
                            <div class="text-muted e-nusx-8">რეგისტრაციის ქვეყანა </div>
                            <div class="e-eng-font">
                            {{ RequestDetailsData.registrationCountry }}
                            </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            <div class="text-muted e-nusx-8">მისამართი </div>
                            <div class="e-nusx-7">
                            {{ RequestDetailsData.address }}
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div class="col col-6">
                    <b-list-group :flush="true">
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <div class="text-muted e-nusx-8">მოთხოვნის ნომერი</div>
                        <div class="e-eng-font">
                            {{ RequestDetailsData.id}}
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <div class="text-muted e-nusx-8">მოთხოვნის დრო</div>
                        <div class="e-eng-font">
                            {{ RequestDetailsData.recDate}}
                        </div>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <div class="text-muted e-nusx-8">მომხმარებელი</div>
                        <div class="e-nusx-7">
                            {{ RequestDetailsData.userFirstName }} {{ RequestDetailsData.userLastName }}
                        </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div class="col col-12 bordered pt-5">
                    <div class="card">
                        <h6 class="card-header e-nusx-5 e-ts-09rem pb-1 pt-1">კომენტარები</h6>
                            <div class="card-body mb-1">
                                <div class="e-loader-back" v-if="commentsLoading">
                                    <div class="e-loader-content">
                                        <div class="ball-clip-rotate-multiple">
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <div class="e-nusx-8 e-bold e-loader-text">მუშავდება...</div>
                                    </div>
                                </div>
                                <div class="row">
                                <perfect-scrollbar always-visible :options="{ suppressScrollX: true, wheelPropagation: true}" class="chat-messages chat-scroll p-4 w-100" style="height: 100px; width: 100%">
                                    <div v-for="comment in comments" :key="comment.ID" :class="`chat-message-${comment.userName === WHBL_item.creatorUserName ? 'right' : 'left'}`" class="mb-2 w-100">
                                    <div>
                                            <!-- <img :src="`${publicUrl}img/avatars/${comment.username === WHBL_item.creatorUserName ? user.avatar : chatUser.avatar}`" class="ui-w-40 rounded-circle" alt> -->
                                        <div class="font-weight-semibold mb-1">{{comment.userName === WHBL_item.creatorUserName ? 'თქვენ' : comment.userName}}</div>
                                        <div class="text-muted small text-nowrap mt-1">
                                        <p class="text-muted small e-ts-05rem e-eng-font mt-1 mb-0">{{comment.recDate | momentDateOnly}}</p>
                                        <p class="text-muted small e-ts-05rem e-eng-font mb-0">{{comment.recDate | momentTimeOnly}}</p>
                                        </div>
                                    </div>
                                    <div class="flex-shrink-1 bg-lighter rounded py-2 px-3" :class="comment.userName === WHBL_item.creatorUserName ? 'mr-3' : 'ml-3'">
                                            <!-- <div class="font-weight-semibold mb-1">{{comment.userName === WHBL_item.creatorUserName ? 'თქვენ' : comment.userName}}</div> -->
                                            {{comment.commentText}}
                                    </div>
                                    </div>
                                </perfect-scrollbar>
                                <!-- / .chat-messages -->
                                <!-- Chat footer -->
                                <hr class="border-light m-0">
                                    <div class="flex-grow-0 w-100">
                                        <b-input-group>
                                        <b-input placeholder="დაამატე კომენტარი" class="e-nusx-8" v-model="CommentText"/>
                                        <b-btn variant="primary" slot="append" class="e-mtavr-17 btn-xs" @click="AddComment(CommentText)">დამატება</b-btn>
                                        </b-input-group>
                                    </div>
                                    <!-- / Chat footer -->
                                    </div>
                                </div>
                    </div>
                </div>
              </div>
            </perfect-scrollbar>
            </div>
        </b-sidebar>

    </div>
    </template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import { ge } from 'vuejs-datepicker/dist/locale'
import PerfectScrollbar from '@/vendor/libs/perfect-scrollbar/PerfectScrollbar'
import moment from 'moment'
export default {
  props: ['RequestDetailsData'],
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      WHBL_item: {},
      commentsLoading: false,
      // currentUser: this.$store.getters.GetCurrentUser,
      CommentText: '',
      comments: [],
      filtershowPop: false,
      filterfullCountryList: [],
      filterfilteredCountriesList: [],
      editing: false,
      decisionTypes: this.$store.getters.GetDecisionTypes,
      locale: ge,
      variant: 'dark',
      variants: [
        'transparent',
        'white',
        'light',
        'dark',
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info'
      ],
      filterObject: {
        columnFilters: {
          countryISO: ''
        }
      },
      activeUsers: []
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.GetCurrentUser
    }
  },
  methods: {
    toggleBodyScrollbar (visible) {
      const body = document.getElementsByTagName('body')[0]
      if (visible) {
        console.log(this.RequestDetailsData)
        this.GetCommentsByRequestId(this.RequestDetailsData.id)
        body.classList.add('overflow-hidden')
      } else { body.classList.remove('overflow-hidden') }
    },
    GetCommentsByRequestId (id) {
      this.commentsLoading = true
      const reqParams = {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
      BaseService.GetCommentsByRequestId(reqParams, id)
        .then(res => {
          this.commentsLoading = false
          // console.log(res)
          if (res.data.success) {
            this.comments = res.data.result
          } else {
            console.log('Error: ' + res)
          }
        })
    },
    AddComment (commentText) {
      console.log(this.currentUser)
      this.commentsLoading = true
      const header = {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
      const commentItem = {
        id: 0,
        commentText: commentText,
        userId: this.currentUser.id,
        userName: this.currentUser.userName,
        recDate: moment(Date.now()).format(),
        requestId: this.RequestDetailsData.id,
        deleteStatus: false,
        organisationUserId: 0
      }
      BaseService.AddComment(header, commentItem)
        .then(res => {
          // console.log(res)
          if (res.data.success) {
            this.CommentText = ''
            this.GetCommentsByRequestId(this.RequestDetailsData.id)
            this.commentsLoading = false
          }
        })
    }
  },
  mounted () {
    this.filterfullCountryList = this.$store.getters.GetCountriesList
    this.activeUsers = this.$store.getters.GetActiveUsersList
    // console.log('SlideBar')
    // console.log(this.RequestDetailsData)
  },
  filters: {
    momentTimeOnly: function (date) {
      return moment(date).format('HH:mm')
    },
    momentDateOnly: function (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    momentDateAndTime: function (date) {
      return moment(date).format('HH:mm DD.MM.YYYY')
    }
  }
}
</script>

    <style>

    </style>
